<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentFollowUp.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          { text: $t('studentFollowUp.pageTitle'), active: true }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="ts-flex justify-content-start">
            <ts-button
              color="info"
              outline
              @click="$router.push({ name: 'student-follow-up-create' })"
              >{{ $t('add_new') }}</ts-button
            >
            <!-- <div class="col-md-8">
              <ts-date-picker-input v-model="action_date" />
            </div> -->
          </div>
          <div class="ts-flex-grow"></div>
          <div class="ts-flex justify-content-end">
            <label class="mt-2 mr-2">{{ $t('studentFollowUp.actionStatus') }} :</label>
            <a-select
              v-model="action_status"
              style="width: 140px"
              class="ts-mr-2"
            >
              <a-select-option :value="null">All</a-select-option>
              <a-select-option value="Follow Up">Follow Up</a-select-option>
              <a-select-option value="Accepted">Accepted</a-select-option>
              <a-select-option value="Rejected">Rejected</a-select-option>
            </a-select>
            <a-tooltip placement="top">
              <template #title>
                <span>{{ $t('studentFollowUp.search') }}</span>
              </template>
              <ts-input
                v-model="search"
                :placeholder="$t('search')"
                style="width: 300px"
              />
            </a-tooltip>

            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'responsible_by.name_en'
          }"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry ? record.inquiry.branch.branch_name_en : '' }}
            </td>

            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry ? record.inquiry.full_name_en : '' }}
            </td>
            <td class="text-center">
              {{ record.inquiry ? record.inquiry.gender : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry ? record.inquiry.contact_name : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry ? record.inquiry.contact_number : '' }}
            </td>
            <td class="ts-whitespace-no-wrap">
              {{ record.inquiry ? record.inquiry.from_school : '' }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.action_status }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <span
                v-if="record.action_date"
                class="badge"
                :class="checkDate(record.action_date)"
                >{{ record.action_date }}
              </span>
            </td>
            <td class="text-center">
              <a
                v-if="record.action_status == 'Follow Up'"
                href="#"
                v-tooltip="$t('comment')"
                class="mr-2 text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fa fa-comment"></i>
              </a>
            </td>
          </template>
          <div slot="expand" slot-scope="prop">
            <table class="ts-w-11/12 ts-mx-auto detail">
              <thead>
                <tr class="ts-uppercase ts-bg-gray-200 ts-h-8 ts-text-white">
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                    {{ $t('studentFollowUp.actionDate') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap">
                    {{ $t('studentFollowUp.comments') }}
                  </th>
                  <th class="ts-pl-2 ts-whitespace-nowrap ts-text-center">
                    {{ $t('studentFollowUp.actionStatus') }}
                  </th>
                  <th
                    class="ts-pl-2 ts-text-center ts-whitespace-nowrap ts-text-center"
                  >
                    {{ $t('studentFollowUp.nextActionDate') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="tw-border-b-2"
                  v-for="(comment, index) in prop.record.comment_lists"
                  :key="index"
                >
                  <td class="tw-p-2 tw-whitespace-nowrap ts-text-center">
                    {{ comment.action_date }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ comment.comment }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap ts-text-center">
                    {{ comment.action_status }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap ts-text-center">
                    {{
                      comment.action_status == 'Follow Up'
                        ? comment.next_action_date
                        : ''
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
    <!-- drawer -->
    <a-drawer
      :title="$t('invoice.filter')"
      placement="right"
      :closable="false"
      :visible="visible"
      @close="() => (visible = false)"
      :zIndex="1020"
      width="300px"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <a-select
              style="width: 257px"
              v-model="branch_id"
              :options="branchs"
              showSearch
              mode="multiple"
              :filterOption="
                (input, option) =>
                  option.componentOptions.children[0].text
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
              "
              :maxTagCount="1"
              :maxTagTextLength="17"
              :placeholder="$t('all')"
            >
            </a-select>
          </div>
        </div>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import EditFormComponent from './edit'
import PreviewPdf from './preview-pdf'
import moment from 'moment'

export default {
  name: 'student-follow-up',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('studentFollowUp', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.studentFollowUp.search
      },
      set (newValue) {
        this.$store.commit('studentFollowUp/SET_SEARCH', newValue)
        this.$store.commit('studentFollowUp/RESET_CURRENT_PAGE')
      }
    },
    action_date: {
      get () {
        return this.$store.state.studentFollowUp.action_date
      },
      set (newValue) {
        this.$store.commit('studentFollowUp/SET_ACTION_DATE', newValue)
      }
    },
    branch_id: {
      get () {
        return this.$store.state.studentFollowUp.branch_id
      },
      set (newValue) {
        this.$store.commit('studentFollowUp/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('studentFollowUp.branch') },

        { name: this.$t('studentFollowUp.studentName') },
        {
          name: this.$t('studentFollowUp.gender'),
          style: 'text-align: center'
        },
        { name: this.$t('studentFollowUp.contactName') },
        { name: this.$t('studentFollowUp.contactNumber') },
        { name: this.$t('studentFollowUp.fromSchool') },
        {
          name: this.$t('studentFollowUp.actionStatus'),
          style: 'text-align: center'
        },
        {
          name: this.$t('studentFollowUp.actionDate'),
          style: 'text-align: center'
        },
        { name: this.$t('actions'), style: 'text-align:center;width: 2%' }
      ]
    },
    action_status: {
      get () {
        return this.$store.state.studentFollowUp.action_status
      },
      set (newValue) {
        this.$store.commit('studentFollowUp/SET_ACTION_STATUS', newValue)
      }
    }
  },
  methods: {
    checkDate (date) {
      var today = moment()

      var next_action_date = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD')
      var diff = today.diff(next_action_date, 'days')

      if (diff < 0) {
        return 'badge-primary'
      } else if (diff < 7) {
        return 'badge-warning'
      } else {
        return 'badge-danger'
      }
    },
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'studentFollowUp/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    edit (editData) {
      this.$modal.show(
        EditFormComponent,
        {
          editData: editData
        },
        {
          height: 'auto',
          width: '500px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    preview () {
      this.$modal.show(
        PreviewPdf,
        {
          data: []
        },
        {
          height: 'auto',
          width: '70%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500),
    action_date: debounce(function (action_date) {
      this.fetchData({ action_date })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    action_status: debounce(function (value) {
      this.fetchData({ action_status: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    if (_.isEmpty(to.params) && to.name != 'student-follow-up-create') {
      this.$store.commit('studentFollowUp/RESET_STATE')
    }
    next()
  }
}
</script>
